import { API } from "../types";

interface APIAction {
    type: API;
    route: string;
    data: any;
}

export const createAPIAction = (data: any, route: any) => (type: API): APIAction => {
    return { data, route, type };
};

// const compose = (...fns: any[]) => fns.reduceRight((f, g) => (...args: any[]) => f(g(...args)));
